import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { baseApi } from "./api/baseApi";
import authReducer from "./auth-slice";
import aiReducer from "./ai-slice";

export const reduxStore = configureStore({
  reducer: {
    auth: authReducer,
    ai: aiReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

// Lets queries opt into refetchOnFocus / refetchOnReconnect (notifications,
// the AI sidebar).
setupListeners(reduxStore.dispatch);

export type RootState = ReturnType<typeof reduxStore.getState>;
export type AppDispatch = typeof reduxStore.dispatch;
